import angular from 'angular';
import template from './template.html';
import './style.scss';

export class PredictionScore {
    $onChanges() {
        this.circleClass = this.getCircleClass(this.predictionScore);
        this.formattedPredictionScore = this.getFormattedPredictionScore(this.predictionScore);
        this.isFullPercentClass = this.isFullPercent(this.predictionScore);
    }

    getFormattedPredictionScore(predictionScore) {
        return `${(predictionScore * 100).toString().split('.')[0]}%`;
    }

    getCircleClass(predictionScore) {
        if (predictionScore < 1.0/3.0) {
            return 'empty';
        }

        if (predictionScore >= 1.0/3.0 && predictionScore <= 2.0/3.0) {
            return 'half';
        }

        return 'full';
    }

    isFullPercent(predictionScore) {
        return predictionScore >= 95.0/100.0;
    }
}

export const PredictionScoreConfiguration = {
    template,
    bindings: {
        predictionScore: '<',
    },
    controller: PredictionScore,
    controllerAs: 'predictionScoreCtrl'
};

angular.module('TALENYA-FE').component('predictionScore', PredictionScoreConfiguration);
